import { apiClient } from '@/api/client';
import type { SupportReportRequest, SupportReportResponse } from '@/api/types';

export async function reportError(payload: SupportReportRequest): Promise<SupportReportResponse> {
  const { data } = await apiClient.post<SupportReportResponse>(
    '/api/v1/support/error-report',
    payload
  );
  return data;
}
